<template>
  <div class="list-group-container">
    <div>
      <div class="company-info-section">
        <p>Company Information</p>
      </div>
      <div class="row">
        <div class="form-group profile-pic text-center col-md-4 col-sm-12">
          <div class="text-center">
            <img :src="profilePicture" class="mx-auto" width="160px" height="auto" />
            <br />

            <div>
              <input
                type="file"
                name="company-logo-file"
                id="company-logo-file"
                class="input-file"
                accept="image/jpeg, image/png"
                @change="previewImage"
              />
              <i class="fas fa-camera"></i>
              <label for="company-logo-file" id="upload-label-link">Change logo</label>
            </div>
          </div>
        </div>

        <div class="col-md-8 col-sm-12 px-5">
          <InputComponent
            class="form-group"
            type="text"
            for="input-name"
            label_text="Name"
            attribute="Name"
            placeholder="Company Name"
            v-model="form.company_name"
            :v="$v.form.company_name" />

          <InputComponent
            class="form-group"
            type="text"
            for="input-mobile-number"
            label_text="Contact Number"
            attribute="Contact Number"
            placeholder="Contact Number"
            v-model="form.company_phone"
            :v="$v.form.company_phone" />

          <div class="form-group">
            <label for="building-type">
              How do you identify your company or organization?
            </label>

            <div class="form-check" v-for="d in useCategories" :key="d.id">
              <input class="form-check-input"
                v-model="form.building_type"
                type="radio"
                :name="d.name"
                :value="d.value">
              <label class="form-check-label">{{ d.value }}</label>
            </div>
          </div>

          <InputComponent
            class="form-group"
            type="text"
            for="input-company-background"
            label_text="Company Background"
            attribute="Company Background"
            placeholder="Company Background"
            v-model="form.company_info"
            :v="$v.form.company_info" />
        </div>
      </div>
    </div>

    <br/>

    <div>
      <div class="company-info-section">
        <p>Address Information</p>
      </div>
      <div class="row">
        <div class="col-sm-12 px-5">
          <InputComponent
            class="form-group"
            type="text"
            for="input-country"
            label_text="Country"
            attribute="Country"
            placeholder="Country"
            v-model="form.country"
            :v="$v.form.country" />

          <InputComponent
            class="form-group"
            type="text"
            for="input-province"
            label_text="Province"
            attribute="Province"
            placeholder="Province"
            v-model="form.province"
            :v="$v.form.province" />

          <InputComponent
            class="form-group"
            type="text"
            for="input-city"
            label_text="City"
            attribute="City"
            placeholder="City"
            v-model="form.city"
            :v="$v.form.city" />

          <InputComponent
            class="form-group"
            type="text"
            for="input-building-name"
            label_text="Building Name"
            attribute="Building Name"
            placeholder="Building Name"
            v-model="form.building_name"
            :v="$v.form.building_name" />

          <InputComponent
            class="form-group"
            type="text"
            for="input-company-unit-floor"
            label_text="Floor and unit number"
            attribute="Floor and unit number"
            placeholder="Floor and unit number"
            v-model="form.company_floor"
            :v="$v.form.company_floor" />

          <InputComponent
            class="form-group"
            type="text"
            for="input-building-address"
            label_text="Address"
            attribute="Address"
            placeholder="Address"
            v-model="form.building_address"
            :v="$v.form.building_address" />
        </div>
      </div>
    </div>

    <div class="company-info-section">
      <p>Other Details</p>
    </div>

    <div class="row">
      <div class="col-sm-12 px-5">
        <div class="form-group">
          <label for="building-owner">
          Are you responsible on managing the building premises?
          <br />Eg. Handles concierge and receptions.
          </label>

          <div class="form-check-container">
            <div class="form-check form-check-inline">
              <input v-model="form.is_building_owner"
                class="form-check-input"
                type="radio"
                name="for-building-owner"
                id="yes-building-owner" value="true">
              <label class="form-check-label" for="yes-building-owner">Yes</label>
            </div>

            <div class="form-check form-check-inline">
              <input v-model="form.is_building_owner"
                class="form-check-input"
                type="radio"
                name="for-building-owner"
                id="no-building-owner"
                value="false">
              <label class="form-check-label" for="yes-building-owner">No</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <section>
      <small v-if="errorMessage" class="form-text text-muted error-message">
        {{ errorMessage }}
      </small>
    </section>

    <section class="d-flex justify-content-center mb-4">
      <button @click="checkForm()" type="submit" class="btn btn-primary">
        Update
      </button>
    </section>

  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

import InputComponent from '@/components/form/InputComponent'

const placeholderImage = 'http://placehold.jp/ebf0f5/9db4cc/150x150.png?text=YP'

export default {
  components: {
    InputComponent
  },
  data() {
    return {
      profilePicture: this.form.company_logo_url || placeholderImage
    }
  },
  props: {
    form: Object,
    previewImage: Function,
    errorMessage: String,
    useCategories: Array,
    validateForm: Function,
    updateErrorState: Function
  },
  validations: {
    form: {
      company_name: { required },
      company_phone: { required },
      company_info: { required },
      building_type: { required },
      is_building_owner: { required },
      country: { required },
      province: { required },
      city: { required },
      building_name: { required },
      building_address: { required },
      company_floor: { required },
    }
  },
  methods: {
    checkForm() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.updateErrorState(false)
      } else {
        this.updateErrorState(true)
      }
      this.validateForm()
    }
  }
}

</script>

<style scoped>
.company-info-section {
  background-color: #fafafa;
}

.company-info-section p {
  padding-top: 30px;
  padding-left: 25px;
  padding-bottom: 30px;
  font-weight: bold;
  color: #6c757d;
}
</style>



// WEBPACK FOOTER //
// src/containers/business_profile/ProfileForm.vue